import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, message, FormInstance } from 'antd';

import { useOwnerDetails } from 'api/owners';
import { hostToolsApi } from 'api/partners';
import { Spin, Typography, Modal, InputUIKit } from 'ui-kit';

import './PartnerConnect.scss';
import { useSignedUser } from 'api/auth';

HostToolsConnect.propTypes = {
  visible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default function HostToolsConnect({ visible, onSubmit, onClose }) {
  const { data: user } = useSignedUser();
  const { invalidate } = useOwnerDetails(user?.owner_id);
  const [formDetails, setFormDetails] = useState({ integrationToken: '' });
  const [isLoading, setLoading] = useState(false);

  const formRef = useRef<FormInstance | null>(null);

  const handleSubmit = () => {
    formRef.current.validateFields().then((values) => {
      setLoading(true);
      hostToolsApi
        .createOauth({ owner: user.owner_id, integrationToken: values.integrationToken })
        .then((res) => {
          if (res.ok) {
            message.success('Integration token saved successfully!');
            setFormDetails({ integrationToken: values.integrationToken });
            invalidate();
            onSubmit();
            setLoading(false);
          } else {
            message.error(res.data || 'Error adding integration token!');
          }
        });
    });
  };

  return (
    <Modal
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Submit"
      okButtonProps={{ disabled: isLoading }}
      cancelButtonProps={{ hidden: true, disabled: true }}
    >
      <Spin spinning={isLoading}>
        <Typography variant="body1">Add your Host Tools Integration Token here:</Typography>

        <Form ref={formRef} layout="vertical" initialValues={formDetails}>
          <div>
            <Form.Item
              name="integrationToken"
              rules={[
                {
                  required: true,
                  message: 'Please input your integration token',
                },
              ]}
            >
              <InputUIKit placeholder="Integration Token" />
            </Form.Item>
          </div>
        </Form>
        <Typography variant="caption">
          Don’t have a token yet? Head over to our{' '}
          <a
            href="https://app.hosttools.com/settings"
            target="_blank"
            rel="noreferrer"
            className="Integration_external_link"
          >
            API & Integrations
          </a>{' '}
          and copy you Access Token.
        </Typography>
      </Spin>
    </Modal>
  );
}
